<div class="mb-[24px]">
	<div>
		<!-- Services -->

		<div class="flex flex-row justify-between mt-[24px] py-2 min-h-[40px]">
			<p class="text-dark-grey font-semibold text-font-16">
				{{ 'PACKAGES.SERVICES' | translate }}
			</p>

			<button
				*ngIf="viewMode && isEditMode && !packageData?.hasBooking"
				(click)="viewMode = !viewMode"
				class="inline-block text-link text-font-14"
			>
				<img class="inline-block" src="./assets/images/edit-blue.svg" alt="" />

				{{ 'ACTIONS.EDIT' | translate }}
			</button>
		</div>
		<div
			*ngIf="!isEditMode && !packageData?.packageServices?.length"
			class="flex justify-center w-full h-[160px] bg-off-white custom-shadow rounded-12px"
		>
			<button
				(click)="addServiceMode.emit(true)"
				class="bg-gradient px-[16px] py-[10px] text-off-white h-[42px] m-auto rounded-6px text-font-14"
			>
				<span class="me-[8px]">+</span>
				{{ 'PACKAGES.ADD_SERVICE' | translate }}
			</button>
		</div>
		<div
			*ngIf="isEditMode || packageData?.packageServices?.length"
			class="flex flex-col gap-[14px] rounded-12px bg-off-white relative"
		>
			<div>
				<div class="custom-table overflow-x-auto">
					<table class="mat-elevation-z8 bg-transparent w-full relative">
						<thead class="bg-light">
							<tr class="border-b-[1px] border-secondry-color-Gray">
								<td
									class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
								>
									{{ 'PACKAGES.SERVICES_NAME' | translate }}
								</td>

								<td
									class="text-end text-font-14 leading-[22px] text-medium-gray py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
								>
									{{ 'PACKAGES.DURATION' | translate }}
								</td>
							</tr>
						</thead>

						<tbody class="bg-grey-background">
							<tr
								*ngFor="let package of packageData?.packageServices"
								class="border-b-[1px] border-secondry-color-Gray"
							>
								<td
									class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
								>
									{{
										translate.currentLang == 'en'
											? package?.name?.en
											: package?.name?.ar
									}}
								</td>
								<td
									class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-end"
								>
									{{
										package?.duration | customDuration : translate.currentLang
									}}
									<button
										(click)="deleteService(package)"
										*ngIf="!viewMode || !isEditMode"
										class="ms-[24px]"
									>
										<img
											class="inline-block cursor-pointer w-[16px] h-[16px]"
											src="assets/images/delete.svg"
											alt=""
											srcset=""
										/>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<!-- <div
					*ngIf="packageData?.services?.length"
					class="flex justify-center w-full h-[160px] bg-off-white custom-shadow rounded-12px"
				>
					<button
						class="bg-gradient px-[16px] py-[10px] text-off-white h-[42px] m-auto rounded-6px"
					>
						<span class="me-[8px]">+</span>
						{{ 'PACKAGES.ADD_SERVICE' | translate }}
					</button>
				</div> -->

				<div
					*ngIf="
						!viewMode || (!isEditMode && packageData?.packageServices?.length)
					"
					class="flex justify-end mt-[12px] text-[#007AFF]"
				>
					<button
						class="flex mx-2 mt-2 p-[6px]"
						(click)="addServiceMode.emit(true)"
					>
						<span class="me-[8px]">+</span>
						<p>{{ 'PACKAGES.ADD_ANOTHER_SERVICES' | translate }}</p>
					</button>

					<div *ngIf="!viewMode && isEditMode" class="flex items-center">
						<button
							(click)="viewMode = !viewMode"
							class="py-[10px] px-[24px] border-[1px] border-[#D9DBE9] rounded-6px text-dark-grey my-0 max-mobile:text-[8px] max-mobile:px-12px max-mobile:py-[6px] ltr:mr-12px rtl:ml-12px"
						>
							{{ 'ACTIONS.CANCEL' | translate }}
						</button>

						<button
							(click)="onSaved(true); viewMode = !viewMode"
							class="bg-gradient text-off-white py-[10px] px-[24px] rounded-6px max-mobile:px-12px max-mobile:py-[6px] max-mobile:text-[8px] max-mobile:m-0 max-mobile:leading-[20px]"
						>
							{{ 'ACTIONS.SAVE' | translate }}
						</button>
					</div>
				</div>

				<!-- Action Buttons start -->
				<!-- <div class="flex justify-end mt-3" *ngIf="editMode && !isAddMode">
					<div class="flex" (click)="changeEditMode(); isChanged = false">
						<button
							class="border border-solid border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
							mat-button
						>
							{{ 'ACTIONS.CANCEL' | translate }}
						</button>

						<button class="bg-gradient text-off-white rounded" mat-button>
							{{ 'ACTIONS.SAVE' | translate }}
						</button>
					</div>
				</div> -->
				<!-- Action Buttons End -->
			</div>
		</div>
	</div>
</div>
